/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

export const getSkipValidateCart = (state) => state?.mfeCheckout?.validateCart?.skipValidateCart;

export default {};
